import { Alert } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { Box } from '@mui/material';


export const SuccessFailAlert: React.FC<{ isSubmitSuccess: boolean | null }> = ({ isSubmitSuccess }) => {
  const l10n = useL10n();

  if (isSubmitSuccess === null) return null;

  return (
    <Box mb={4} mt={2.5}>
      {isSubmitSuccess === true && (
        <Alert severity="success" showIcon={false} title={l10n.support.submitSuccess.title}>
          {l10n.support.submitSuccess.subtitle}
        </Alert>
      )}
      {isSubmitSuccess === false && (
        <Alert severity="error">
          {l10n.support.submitFail.desc}
        </Alert>
      )}
    </Box>
  );
};
